export default {
    methods: {
        __(label) {
            if (JACKF.translations[label]) {
                return JACKF.translations[label]
            }
            return label
        },
    }
}
